// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__P7h8c","dragIcon":"SortableItem_dragIcon__1tOJq","disabled":"SortableItem_disabled__YPqUm"};